import React, {useEffect, lazy} from 'react';
import { SpotlightTrigger } from "@iscr/views/UIelems/Spotlight";
import {Link, useLocation, useNavigate} from 'react-router'
import withSuspense from "xAppLib/libs/withSuspense";

import user_model from 'models/user_model';
import AdminMenu from '../MenuNav/AdminMenu'
import MainMenuItems from '../MenuNav/MainMenuItems'
import SideAwareDropdown from 'xAppLib/MenuNav/SideAwareDropdown'
import {useAppContext, useUser} from 'xAppLib/Hooks';
import UserAvatar from 'xAppLib/Users/UserAvatar';
import AppendIf from './AppendIf';
import ResultsBanner from 'views/UIelems/ResultsBanner'
const ApprovalBadge = withSuspense(lazy(() => import('views/instcons/InstCons_Approve_WR').then(module => ({ default: module.ApprovalBadge }))))
import LoginPopup from '../Users/LoginPopup';
import UrgentFollowupBanner from "views/UIelems/UrgentFollowupBanner";
import MegaMenu from '../MenuNav/MegaMenu';
import { cls } from 'views/NUI/utils'
import SIcon from '../../views/NUI/StreamlineIcons/SIcon';
import NeedReviewBanner from "../../views/UIelems/NeedReviewBanner";
import NeedeScriptBanner from "../../views/UIelems/NeedeScriptBanner";
import Badge from "views/NUI/Badge";
import gtm from 'xAppLib/providers/gtm';
import IcosmMenu from '../MenuNav/IcosmMenu';
import NotificationBannersApp from '../../notifications/view/app/NotificationBannersApp';
import { useNotificationToasts } from '../../notifications/hooks/useNotificationToasts';
import { useDynamicNotifications } from '../../notifications-plugins/useDynamicNotifications';
import { useRegisterNotificationPlugins } from '../../notifications-plugins/useRegisterNotificationPlugins';
import ConsultWaitTimeIndicator from '@iscr/components/ConsultWaitTimeIndicator';
import { HomeMenu } from '../../views/UIelems/v2/Header/HomeMenu';
import { useProfile } from '../Hooks';
import { MainMenuItem, UserMenuItem } from '../../views/UIelems/v2/UserMenuItem';
import PharmacyButtonWithCartCount from "../../views/ecommerce/components/PharmacyButtonWithCartCount";
import { DropdownMenu } from '../../views/UIelems/v2/DropdownMenu';
import { Menu } from "@headlessui/react";
import { Button } from '../../components/ui/button';

const admin_menu = (lvl) => {
	return  <SideAwareDropdown
				cls="admin-menu"
				items={(isRight, isEnter)=><AdminMenu isRight={isRight} isEnter={isEnter} level={lvl} />}
				trigger={<React.Fragment><i aria-hidden="true" className="is-icon chess-king" />Admin</React.Fragment>} 
			/>
}

const IS2LoginButton = ({showMenu, onToggleMenu}) => {
	const loc = useLocation()
	const navigate = useNavigate();
	const curr_page = loc.pathname
	const embedded_auth_variant = useAppContext('embedded_auth_variant');

	const handleLinkClick = () => {
		const isEmbedded = embedded_auth_variant !== undefined

		if (isEmbedded) {
			app.trigger(app.events.SET_AUTH_EMBED_VAR, embedded_auth_variant === 'login' ? 'signup' : 'login')
		} else {
			navigate(curr_page === '/login' ? '/signup' : '/login')
		}
	}

	const label = (curr_page === '/login' || embedded_auth_variant === 'login') ? 'Create account' : 'Log in'

	return <MainMenuItem
			clsn={cls(app.runtime.theme === 'iscr2' && 'ui primary button item rounded-md sign-in', ['login', 'signup'].includes(embedded_auth_variant) && '!bg-is2-yellow-500')}
			active={curr_page === '/login' || curr_page === '/signup'}
			onClick={_=> showMenu && onToggleMenu(!showMenu) || handleLinkClick()}
			key={'header_menu_mob_login'}
			testId="link-login"
			id={'is2-login-button'}
		>
			{label}
		</MainMenuItem>
}

const Header = ({ onToggleMenu, showMenu }) => {
	const loc = useLocation()
	const user = useUser()

	useNotificationToasts();
	useRegisterNotificationPlugins();
	useDynamicNotifications();

	const [prof] = useProfile();
	const curr_page = loc.pathname
	const admin = user.claims.admin
	
	const navig = (app.site_status?.show_navigator || app.user?.claims?.admin || app.user?.claims?.supp || app.user?.claims?.mark) && !curr_page.startsWith('/m/pharm') && app.settings.iscr && !app.settings.iscr2
	const showWaitTimeIndicator = app.acl.is_work && app.settings.iscr2 && user.user_in && curr_page === "/";
					 
	const extra = app.acl.is_work

	const user_menu = [
		...(app.site_status?.notifications?.enable_indicator?.includes?.(app.runtime?.app)) ? [{
			name: 'Notifications',
		}]:[],
		{
			name: 'Account',
			icon: 'profile-circle',
			trigger: prof?.first_name + " " + (prof?.last_name?.[0]||'')
		}
	]

	useEffect(_=>{
		app.on(app.events.SIDEMENU, ({view}) => {
			onToggleMenu(true)
		})
	},[])

	if (app.settings.is_bare)
		return null

	const menu_alt = user.user_in || ['/privacy', '/customer-terms-and-conditions', '/platform-terms-and-conditions'].includes(location.pathname.replace(/\/$/, ''))
 
	return (
		<>
			<header id="main-menu" className={cls(extra && 'extra', menu_alt ? 'user-in' : 'no-user')}>
			
			{/* {(app.settings.icosm && !user.user_in) && <Link className="-my-4 text-[13px] tracking-[.17em] mb-4 block h-[49px] uppercase !bg-white text-black hover:underline !w-full text-center py-4" to="/qld-cosmetic-nurses-urgent-update"><div className="w-full">ATTN: QLD Cosmetic Nurses - S4 UPDATE</div></Link>} */}
			
			<div className="container !w-auto !max-w-full">

				{/* Top Menu Row */}
				<div className="top-menu menu !items-center ">

					{/* Side Menu IC */}
					{(app.settings.icosm && !app.runtime.hide_nav) &&
						<MainMenuItem header onClick={_=> onToggleMenu(true)} clsn="burger md:!hidden !text-white">
							<SIcon name="burger-menu" cls="h-[40px] w-[40px]" bold/>
						</MainMenuItem>
					}
					
					{/* Logo */}
					<MainMenuItem header to='/' clsn="shrink-0 lg:mr-4">
						<img className='logo' alt={app.runtime.name} src={app.settings.icosm && menu_alt && app.runtime.sidemenuLogo || app.runtime.headerLogo || '/images/logos/instant-scripts-logo-IS2-blue.svg'} />
						{__LOCAL_PROD__ && <Badge small color='red' className="ml-2 scale-75 origin-top-left">PROD</Badge> }
					</MainMenuItem>

					{showWaitTimeIndicator && <div className={cls("relative lg:ml-0 xl:ml-8 hidden lg:block lg:mr-8 xl:mr-4 h-8")}><ConsultWaitTimeIndicator basic badge color="bg-is2-green" /></div>}

					{/* Main Menu */}
					{!app.runtime.hide_nav && 
						<div className={cls(`main-menu-cont hidden ${app.settings.icosm ? 'md:flex' : 'lg:flex'} flex-auto justify-end flex-nowrap`)}>
							{!app.settings.iscr2 && app.settings.iscr && !app.settings.is_mob_sz && app.acl.app_use && <MegaMenu />}
							{app.settings.icosm && !app.settings.is_mob_sz && !user.user_in ? <IcosmMenu />
							:
								<div className={cls('flex items-center menu', 
									app.settings.iscr && extra && 'md:hidden' ||
									app.settings.is_cmg && !extra && 'hidden cmg-md:flex' ||
									app.settings.icosm && (extra && !admin && 'md:flex') || 
									!app.settings.iscr && (extra && user.user_in && 'hidden')
								)}>
									<MainMenuItems />
									{user.claims.admin && admin_menu(0)}
								</div>
							}
						</div>
					}
					
					{/* Login */}
					<div position="right" className={cls('menu user-menu flex items-center md:gap-4', app.settings.iscr2 ? 'gap-0 ml-auto' : 'gap-2 md:ml-auto ')}>
						{navig &&
							<Button
								className="ui green button rounded-md mt-6 sm:mt-0"
								id="get-started"
								as={Link}
								to='/navig'
								onClick={()=>gtm.log('wizard', 'navig', {navig_btn: 'open'})}
								key={'header_menu_navig'} >Get Started</Button>
						}
						{user.user_in==null
								&& <div className="w-5 h-5 border-is2-gray-body border-2 border-t-is-gray-25 rounded-full animate-spin"></div>
						}
						{app.settings.icosm && !app.acl.is_work &&
							<MainMenuItem
								label={'Join'}
								clsn='join'
								active={curr_page === '/join'}
								as={Link}
								to={'/join'}
								key={'header_menu_mob_login'} />
						}
						{(user.user_in==false || app.runtime?.login_type=='popup'&&app.state.in_sgup_st2)
							&& !(app.dvc.org.type=='pharm'
								&& (document.location.hostname=="pharmapp.instantscripts.com.au"||document.location.hostname=="safe-scripts.firebaseapp.com")
								&& (app.settings.is_tablet || app.settings.is_mob)
								)
							&& !app.settings.is_cmg
							&& (app.runtime?.login_type=='popup' ?
								<LoginPopup />
								:
								<IS2LoginButton showMenu={showMenu} onToggleMenu={onToggleMenu}/>
							)
						}

						{app.acl.can_spotlight_search && <SpotlightTrigger />}

						{user.user_in && <>
							<ApprovalBadge/>
							{app.settings.iscr2 && user.user_in &&
								user_menu.map((el, i) => {
										return <UserMenuItem
													key={i}
													{...el}
												/>
								})
							}
							{app.runtime.theme === 'iscr2' && app.acl.is_usr && <PharmacyButtonWithCartCount />}
							
							{!app.settings.iscr2 && 
								<DropdownMenu 
									showChevron={false}
									align="right"
									id="profile"
									clsn="mt-2 [&_.item]:text-is2-gray-700 [&_.item]:py-3 absolute absolute bg-white flex flex-col text-is2-gray-700 shadow-sm z-[11] rounded-sm h-fit border cursor-pointer focus-visible:outline-none"
									trigger={app.settings.icosm && <><span className="hidden md:block">PROFILE</span><span className="block md:hidden"><img src="https://storage.googleapis.com/icosm/2/ic-login-mobile-button.svg" alt='Login Mobile'/></span></>|| <UserAvatar />}
									items={
										<>
											<div className="text-sm font-bold px-4 pt-4 pb-2">
												<AppendIf
													cont={user.name || user.email}
												/>
												<AppendIf
													cont={user.org?.name}
													beforeContent={<br />}
												/>
												<AppendIf
													cont={user.role}
													beforeContent={<React.Fragment><br />(</React.Fragment>}
													afterContent=")"
												/>
											</div>
											<hr className="!my-1 border-is2-gray-100" />
											<Menu.Item className="item" as={Link} to='/profile' ><i className="icon user" />My profile</Menu.Item>
											{app.acl.is_mang && app.acl.is_cosm && <Menu.Item as={Link} to='/org/my-clinic-profile' className="item"><i className="icon building" />Clinic Profile</Menu.Item>}
											{app.acl.is_nurse && <Menu.Item as={Link} to='/cosm/audit/list/practitioner' className="item" ><i className="icon certificate" />Audit history</Menu.Item>}
											{user.usePassword && <Menu.Item as={Link} to='/profile-password' className="item"><i className="icon lock" />Change password</Menu.Item>}
											{(app.acl.is_admin || app.acl.is_nurse || app.acl.is_doc) && (
												<Menu.Item as={Link} to='/vidcall-troubleshooting' className="item"><i className="icon video"/>Test VidCall</Menu.Item>
											)}
											<Menu.Item as={Link} onClick={()=>user_model.logout()} className="item"><i className="icon user close"/>Logout</Menu.Item>
									</>
								}/>
							}
						</>}

						{/* Side Menu */}
						{((!app.settings.iscr && !app.runtime.hide_nav) || app.settings.iscr )&& ((user.user_in && app.settings.icosm) || !app.settings.icosm) &&
							<button data-testid="burger-menu"
								onClick={_=> onToggleMenu(!showMenu)} 
								className={cls('item burger !text-white cursor-pointer flex items-center !p-0 lg:!pr-2 lg:!ml-3 lg:!pl-5', app.settings.iscr && !app.settings.iscr2 && 'menu-lg:!hidden', (app.settings.icosm && user.user_in) && "!hidden md:!flex xl:!hidden", showMenu && app.settings.iscr2 && "active bg-is2-blue-300 lg:!pr-2")}
								>
								{app.settings.iscr2 && <span className="hidden lg:block">Menu</span>} <SIcon name="burger-menu" svg_cls={app.settings.iscr2 && "w-[20px]"} cls={app.settings.iscr2 ? "p-3" : "h-[40px] w-[40px]"} bold/>
							</button>
						}
					</div>
				</div>
				
				{/* Bottom Row */}
				<div className={cls('flex-auto justify-between min-h-auto mt-0 p-0 ', user.user_in && 'user-in',
						app.settings.icosm && (!extra && user.user_in && 'hidden' || extra && admin && 'flex' || extra && !admin && 'hidden' || !user.user_in && 'hidden md:flex lg:hidden') || !app.settings.iscr && (!extra || !user.user_in) && 'flex lg:hidden'
					)}>
					<div className={cls('w-full flex flex-wrap flex-auto justify-between',
						app.acl.is_pharm && 'md:justify-end')}>
						<MainMenuItems />
						{user.claims.admin && admin_menu(1)}
					</div>
				</div>
				
				{/* Banners  */}

				{!app.site_status?.notifications?.enable_banners?.includes?.(app.runtime?.app) && (
					<div className=" flex-col flex md:flex-row gap-x-2 xs:max-w-3xl max-w-none mx-auto flex-wrap">

						{!app.settings.icosm && <ResultsBanner hide_zero={true} />}
						{app.acl.can_urgent_care && <UrgentFollowupBanner/>}
						{app.acl.can_manual_review && !app.settings.icosm && <NeedReviewBanner/>}
						{app.acl.can_escript_review && !app.settings.icosm && <NeedeScriptBanner/>}
					</div>
				)}
			</div>
		</header>
		
		{app.settings.iscr2 && ["/"].includes(curr_page) && <HomeMenu />}

		{app.site_status?.notifications?.enable_banners?.includes?.(app.runtime?.app) && user?.user_in && (!app.settings.iscr2 || (app.settings?.iscr2 && curr_page !== "/"))
			? (
				<NotificationBannersApp />
			) : null
		}
		</>
	);
}
 
export default Header;
